export default __webpack_public_path__ + "static/media/ico_checkbox_full_gray.2e13bc5a.svg";